export default "__VITE_ASSET__GBAJyxJu__"